'use strict';

wbApp.controller('FranchisesCtrl', ['$scope', 'franchiseSvc', 'tenantSettingSvc',
function ($scope, franchiseSvc, tenantSettingSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.requireTeacherFranchiseLicenses = tenantSettingSvc.settings.requireTeacherFranchiseLicenses;

    if ($scope.requireTeacherFranchiseLicenses) {
        $scope.gridOptions = {
            sortInfo: { fields: ['franchiseName'], directions: ['dsc'] },
            noCommandColumn: true,
            columnDefs: [
                { field: 'franchiseName', displayName: "TXT_LBL_FRANCHISE", sort: 'locale' },
                { field: 'noOfTeachers', displayName: "TXT_LBL_NO_OF_TEACHERS", width: "90px" },
                { field: 'noOfInActiveTeachers', displayName: "TXT_LBL_NO_OF_INACTIVE_TEACHERS", width: "90px" },
                { field: 'noOfTeachersWithoutLicense', displayName: "TXT_LBL_NO_OF_TEACHERS_WITHOUT_LICENSE", width: "90px" }
            ]
        };
    } else {
        $scope.gridOptions = {
            sortInfo: { fields: ['franchiseName'], directions: ['dsc'] },
            noCommandColumn: true,
            columnDefs: [
                { field: 'franchiseName', displayName: "TXT_LBL_FRANCHISE", sort: 'locale' },
                { field: 'noOfTeachers', displayName: "TXT_LBL_NO_OF_TEACHERS", width: "90px" },
                { field: 'noOfInActiveTeachers', displayName: "TXT_LBL_NO_OF_INACTIVE_TEACHERS", width: "90px" }                
            ]
        };
    }

    $scope.franchises = franchiseSvc.getAllAsync(true);

    $scope.tabs = [
    {
        title: 'TXT_FRANCHISES_EMPLOYEES',
        template: "franchise/franchises-tabs/employees.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.onRowSelected = function (data) {
        $scope.selectedFranchise = data;
        $scope.$broadcast('franchiseSelectionChanged', $scope.selectedFranchise);
    }

    $scope.$on('franchiseEmployeeUpdated', function (e, employee) {
        var newData = franchiseSvc.getAllAsync(true);
        newData.$promise.then(function (data) {
            var newFranchise = _.find(data, { franchiseTenantAlias: $scope.selectedFranchise.franchiseTenantAlias });
            if (newFranchise) {
                angular.extend($scope.selectedFranchise, newFranchise);
            } else {
                $scope.franchises = data;
            }
        });
    });

    //$scope.$watch('tabs.activeTab', function (newValue, oldValue) {
    //    $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    //});
}]);